<template>
    <div>
        <router-view v-if="isLoading == false"></router-view>
        <loading v-else/>
    </div>
    <payment-modal
        :id="'top-up-modal'"
        :top-up-type="topUpType"
    >
        <template #header>
            <div class="d-flex">
                <img :src="settingStore.modalLogo" class="mb-2 w-50 mx-auto" alt="creditfixrr">
            </div>
            <h3 class="text-primary text-center mb-1">
                {{ localizationStore.translate("top.up.modal.title") }}
            </h3>
            <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                <div class="alert-body d-flex align-items-center">
                    <vue-feather type="info" size="14" class="mr-50 align-middle top-0" />
                    <span v-html="message"></span>
                </div>
            </div>
            <template v-for="(topUp, name) in planStore.topUps">
                <input
                    type="radio"
                    name="top-up-type"
                    v-model="topUpType"
                    :value="name"
                    :id="`top-up-${name}`"
                    class="custom-control-input"
                />
                <label :for="`top-up-${name}`" class="card radio-box mb-50">
                    <div class="card-body p-75">
                        <div class="d-flex justify-content-between flex-wrap">
                            <h6 class="font-weight-bolder mb-0">
                                {{ localizationStore.translate(`top.up.modal.package.${name}.title`) }}
                            </h6>
                            <h6 class="font-weight-bolder mb-0">
                                {{ localizationStore.translate(`top.up.modal.package.${name}.price`, { price: `$${topUp.price}` }) }}
                            </h6>
                        </div>
                        <p
                            class="card-text"
                            v-html="localizationStore.translate(`top.up.modal.package.${name}.description`, { price: `$${topUp.price}`, credit: topUp.credit })"

                        ></p>
                                                </div>
                </label>
            </template>
        </template>
        <template #footer="{ topUp }">
            <div class="row gy-1 gx-2 mt-75">
                <div class="col-12 text-center">
                    <button type="button" @click.once="topUp" class="btn btn-primary mr-1 mt-1" :key="planStore.paymentBtnKey">
                        {{ localizationStore.translate("top.up.modal.button.save") }}
                    </button>
                    <button @click="closeModal('#top-up-modal')" type="reset" class="btn btn-outline-secondary mt-1" aria-label="Close">
                        {{ localizationStore.translate("top.up.modal.button.cancel") }}
                    </button>
                </div>
            </div>
        </template>
    </payment-modal>
    <template v-for=" (video,index) in videos" :key="index">
        <video-player-model :videoData="video">
            <template #video_title>
                {{video.title}}
            </template>
            <template #video>
                <span v-html="video.source"></span>
            </template>
        </video-player-model>
    </template>
    <chat-modal :id="'chat-modal'" />
    <sale-plans-modal :id="'sale-plans'" />
    <year-end-plans-modal :id="'year-end-sale-modal'" />
</template>
<script>
import {ref} from 'vue'
import Loader from '../report/Loader.vue'
import PaymentModal from '../modals/PaymentComponent'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { usePlanStore } from '../../stores/PlanStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'
import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
import ChatModal from '../modals/Chat';
import SalePlansModal from '../modals/SalePlans'
import YearEndPlansModal from '../modals/YearEndPlans'

export default {
    name:"IndexComponent",
    components: {
        ChatModal,
        'loading': Loader,
        PaymentModal,
        SalePlansModal,
        YearEndPlansModal,
    },
    setup() {
        return {
            isLoading: ref(true),
            localizationStore: useLocalizationStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            topUpType: ref(null),
            closeModal: closeModal,
            openModal,
            videos:ref([
                {
                    id : "dispute_center_video_model",
                    title : "Creditfixrr Dispute Center",
                    type:"youtube",
                    source : "https://www.youtube.com/embed/GAGB9ixOVJE"
                },
            ])
        }
    },
    created() {
        var styles = [
            '/css/vue-tel-input.css',
            '/vendors/css/charts/apexcharts.css',
            '/vendors/css/pickers/flatpickr/flatpickr.min.css',
            '/vendors/css/file-uploaders/dropzone.min.css',
            '/vendors/css/forms/wizard/bs-stepper.min.css',
            '/vendors/css/editors/quill/monokai-sublime.min.css',
            '/vendors/css/editors/quill/quill.snow.css',
            '/css/base/plugins/charts/chart-apex.css',
            '/css/base/pages/app-invoice-list.css',
            '/css/base/plugins/forms/pickers/form-flat-pickr.css',
            '/css/base/pages/app-calendar.css',
            '/css/base/plugins/forms/form-validation.css',
            '/css/base/plugins/forms/form-file-uploader.css',
            '/css/shepherd.css',
            '/css/base/plugins/forms/form-wizard.css',
            '/css/base/plugins/forms/form-quill-editor.css',
            '/css/base/pages/app-email.css',
            '/vendors/css/tables/datatable/responsive.bootstrap.min.css',
            '/vendors/css/tables/datatable/responsive.bootstrap4.min.css',
            '/vendors/css/tables/datatable/buttons.bootstrap4.min.css',
            '/vendors/css/tables/datatable/rowGroup.bootstrap4.min.css',
            '/vendors/css/extensions/plyr.min.css',
            '/css/base/plugins/extensions/ext-component-media-player.css',
            '/css/base/pages/page-knowledge-base.css',
        ];
        if (this.$route.name == 'chat-index') {
            styles = _.without(styles, '/css/base/pages/app-email.css')
        }
        styles.forEach(path => {
            let link = document.createElement("link");
            link.rel = 'stylesheet';
            link.href = path;
            document.head.appendChild(link);
        });
        var scripts = [
            "/vendors/js/charts/apexcharts.min.js",
            '/vendors/js/blockui/blockui.min.js',
            '/vendors/js/extensions/sweetalert2.all.min.js',
            '/vendors/js/pickers/pickadate/picker.js',
            '/vendors/js/pickers/pickadate/picker.date.js',
            '/vendors/js/pickers/pickadate/picker.time.js',
            '/vendors/js/forms/wizard/bs-stepper.min.js',
            '/vendors/js/forms/validation/jquery.validate.min.js',
            // page js file
            // '/js/scripts/phone.js',
            '/js/scripts/social.js',
            '/js/scripts/utilities.js',
            '/js/scripts/extensions/ext-component-blockui.js',
            '/js/scripts/pages/app-calendar-events.js',
            '/js/scripts/pages/app-calendar.js',
            '/js/scripts/image-uploader.js',
            '/js/scripts/shepherd.min.js',
            '/js/scripts/pages/app-email.js',
            '/vendors/js/extensions/toastr.min.js',
            '/vendors/js/extensions/plyr.min.js',
            '/vendors/js/extensions/plyr.polyfilled.min.js',
            '/js/scripts/pages/page-account-settings.js'
        ];
        scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.body.appendChild(tag);
        });
        // Simulating an asynchronous action (e.g., fetching data)
        setTimeout(() => {
            this.isLoading = false; // Set isLoading to false when the data is loaded
        }, 2000);
    }
}
</script>
